export default __webpack_public_path__ + "static/media/Ballroll_00294.5a1cd679.png";